import "@/composables/useNotification";
import ChemicalContainerAttachments from "@/components/chemtracker/ChemicalContainerAttachments.vue";
import { uuidPattern } from "@/lib/raft_generic_helper";
import ChemicalContainerForm from "@/components/chemtracker/ChemicalContainerForm.vue";
import ChemicalContainers from "@/components/chemtracker/ChemicalContainers.vue";
import ChemicalContainersRegulations from "@/components/chemtracker/ChemicalContainersRegulations.vue";
import { useDrupalSettings } from "@/composables/useDrupalSettings";
import DromoTestPage from "@/components/chemtracker/DromoTestPage.vue";

const { config } = useDrupalSettings();

const routes = [
  // URL in RAFT where Vue JS component needs to match the following.
  // Path is used in B4, Alias in B3 if they are different paths.
  {
    path: "/raft/chemtracker/containers",
    name: "chemical_containers",
    component: ChemicalContainers,
    props: true,
  },
  {
    path: "/raft/chemtracker/reports/containers",
    name: "chemical_containers_by_regulation",
    component: ChemicalContainersRegulations,
    props: true,
  },
  {
    path: "/node/:contextNid(\\d+)/chemtracker",
    name: "group_chemical_containers",
    component: ChemicalContainers,
    props: true,
  },
  {
    path: "/raft/chemtracker/container/:uuid(" + uuidPattern + ")/edit",
    name: "attachments_or_edit_form",
    component: ChemicalContainerAttachments,
    props: (route) => ({ uuid: route.params.uuid, editMode: true }),
  },
  {
    path:
      "/node/:contextNid(\\d+)/chemtracker/container/:uuid(" +
      uuidPattern +
      ")/edit",
    name: "group_attachments_or_edit_form",
    component: ChemicalContainerAttachments,
    props: (route) => ({ uuid: route.params.uuid, editMode: true }),
  },
  {
    path: "/raft/chemtracker/container/:uuid(" + uuidPattern + ")",
    name: "chemical_container_attachments",
    component: ChemicalContainerAttachments,
    props: true,
  },
  {
    path:
      "/node/:contextNid(\\d+)/chemtracker/container/:uuid(" +
      uuidPattern +
      ")",
    name: "group_chemical_container_attachments",
    component: ChemicalContainerAttachments,
    props: (route) => ({
      uuid: route.params.uuid,
    }),
  },
  {
    path: "/raft/chemical_container/dromo-test-page",
    name: "dromo_test_page",
    component: DromoTestPage,
  },
];

// Feature flag chemtracker_vuejs_container_inventory_form.
// Only add these new routes if enabled.
if (
  (Object.hasOwn(
    config.chemTrackerConfig,
    "chemtracker_vuejs_container_inventory_form",
  ) &&
    config.chemTrackerConfig.chemtracker_vuejs_container_inventory_form) ||
  config.isB4
) {
  routes.push(
    {
      path: "/raft/chemtracker/add-inventory",
      name: "chemical_add_inventory",
      component: ChemicalContainerForm,
      props: true,
    },
    {
      path: "/node/:contextNid(\\d+)/chemtracker/add-inventory",
      name: "chemical_add_inventory_group_level",
      component: ChemicalContainerForm,
      props: true,
    },
  );
}

export default routes;
